import { render, staticRenderFns } from "./CaptureConfirm.vue?vue&type=template&id=3a4627a2"
import script from "./CaptureConfirm.vue?vue&type=script&lang=js"
export * from "./CaptureConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports